// @ai-generated 2026-08-10T09:40:00+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import { type ApiLocationSnapshot } from '@Model';
import { getSiteLines } from '@utils/requisitionDisplay';
import { type ReactNode } from 'react';
import classes from './AddressLines.module.css';

export interface AddressLinesProps {
    location: ApiLocationSnapshot | undefined;

    /** Rendered when the location carries neither a name nor an address. */
    fallback?: ReactNode;
}

/**
 * An address over two lines: its name in bold, its street and city below. Shared so that a table
 * cell and a detail field cannot drift apart in wording or weight.
 */
export function AddressLines({ location, fallback = '—' }: AddressLinesProps) {
    const { name, address } = getSiteLines(location);

    if (!name && !address) {
        return <>{fallback}</>;
    }

    return (
        <span className={classes.root}>
            <span className={classes.name}>{name}</span>
            {address && <span className={classes.address}>{address}</span>}
        </span>
    );
}
